'use strict';

$(document).ready(function () {

  function getFormData(form) {
    return $(form).serializeArray().reduce(function (obj, item) {
      obj[item.name] = item.value.trim();
      return obj;
    }, {});
  }

  function getFormLGPDDisclaimer(form) {

    var disclaimer = {};

    form.find('.lgpd-disclaimer').each(function () {
      disclaimer.text = $(this).text().replace(/\\n|\s{2,}/gm, ' ').trim();
      disclaimer.url = $(this).find('a').attr('href');
    });

    return disclaimer;
  }

  var form = $('#model-offer-form');
  var brandSlug = form.find('input[name=brand-slug]').val();

  formValidateConfig(form);
  validatorEmail();
  validatorPhone();
  validatorCep();

  form.submit(function (e) {
    e.preventDefault();

    $('.text-danger').hide();

    if ($(this).valid()) {
      var send_lead_model = function send_lead_model() {
        grecaptcha.enterprise.ready(function () {
          grecaptcha.enterprise.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

            data.token = grecaptchaToken;

            $.ajax({
              url: ajaxHandler.url_leads + '/api/jornaldocarro/v1/receive-callback-model',
              type: 'POST',
              data: data,
              success: function success(response) {

                if (response.status) {
                  console.log('lead enviado com sucesso');
                } else {
                  console.log('erro ao enviar lead');
                }
              }
            });
          });
        });
      };

      var data = getFormData($(this));

      data.name = data.fullname.split(' ')[0];
      data.surname = data.fullname.substr(data.fullname.indexOf(' ') + 1);
      data.url_page = window.location.href;
      data.slug = brandSlug;
      data.lgpd_disclaimer = getFormLGPDDisclaimer($(this));
      data.action = 'jc_ajax_model_send_lead';

      var submitButton = $(this).find('button');
      var submitButtonLabel = submitButton.text();
      submitButton.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

      grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

          data.token = grecaptchaToken;

          $.ajax({
            url: ajaxHandler.url,
            type: 'POST',
            data: data,
            success: function success(response) {

              if (response.status) {
                send_lead_model();
                send_offer_lead_success_events(data.offer, response.lead, 'Oferta').then(function () {
                  form.slideUp();
                  $('#form-header-text').text('Obrigado!');
                  $('#form-subheader-text').text('Em breve você receberá um contato para conversar sobre as condições comerciais que possibilitem o fechamento do negócio.');
                  submitButton.prop('disabled', false).text(submitButtonLabel);
                });
              } else {
                $('.text-danger').show();
                submitButton.prop('disabled', false).text(submitButtonLabel);
              }
            }
          });
        });
      });
    }
  });
});